import React, { FC, useContext, useMemo } from 'react';

import { useFormikContext } from 'formik';

import AampeToggleButton from '../../../../components/shared/AampeToggleButton/AampeToggleButton';
import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';
import { FormulaTestMessageType } from '../../../../constants/formula';

import { EditorContext } from '../../../../context/EditorContext';

import usePushIntegrationQuery from '../../../../hooks/pushIntegrations/usePushIntegrationsQuery';

import { FormulaTestMessageFormValues } from 'models/formula.model';

import TestFormulaGroupUserForm from './TestFormulaGroupUserForm';
import TestFormulaOneUserForm from './TestFormulaOneUserForm';

interface TestFormulaFormMainProps {
    handleNeedHelp: () => void;
    isLoading: boolean;
    menuPortalId?: string;
    handleClose?: () => void;
    isModalView?: boolean;
}

const TestFormulaFormMainV1: FC<TestFormulaFormMainProps> = ({
    handleNeedHelp,
    isLoading,
    menuPortalId,
    handleClose,
    isModalView = false,
}) => {
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);

    const { setFieldValue, values } =
        useFormikContext<FormulaTestMessageFormValues>();

    const { data: pushIntegrationData } = usePushIntegrationQuery();

    const providerId = useMemo(() => {
        if (pushIntegrationData && formulaType) {
            const providerId = pushIntegrationData.find((integration) =>
                integration.channels?.includes(formulaType),
            )?.id;
            return providerId;
        }
    }, [pushIntegrationData, formulaType]);

    const resetUserFilters = () => {
        setFieldValue('contact_ids', []);
        setFieldValue('notification_token', undefined);
    };

    return (
        <>
            <StyledAampeToggleButton
                buttons={[
                    {
                        title: 'One user',
                        value: FormulaTestMessageType.OneUser,
                        isLeft: true,
                        isSelected: values.current_state,
                        onChange: () => {
                            setFieldValue(
                                'current_state',
                                FormulaTestMessageType.OneUser,
                            );
                            resetUserFilters();
                        },
                    },

                    {
                        title: 'User group',
                        value: FormulaTestMessageType.GroupUser,
                        isRight: true,
                        isSelected: values.current_state,
                        onChange: () => {
                            setFieldValue(
                                'current_state',
                                FormulaTestMessageType.GroupUser,
                            );
                            resetUserFilters();
                        },
                    },
                ]}
                selectedColor={aampeTheme.colors.neutral09}
            />

            {values.current_state === FormulaTestMessageType.OneUser && (
                <TestFormulaOneUserForm
                    isLoading={isLoading}
                    handleNeedHelp={handleNeedHelp}
                    menuPortalId={menuPortalId}
                    handleClose={handleClose}
                    isModalView={isModalView}
                    providerId={providerId}
                />
            )}
            {values.current_state === FormulaTestMessageType.GroupUser && (
                <TestFormulaGroupUserForm providerId={providerId} />
            )}
        </>
    );
};

const StyledAampeToggleButton = styled(AampeToggleButton)({
    width: '100%',
});

export default TestFormulaFormMainV1;
